import { Controller } from 'stimulus';

class Updates extends Controller {
  // eslint-disable-next-line class-methods-use-this
  connect() {
    this.activeIndex = 0;
    this.total = this.tabTargets.length;
  }

  onPrevClick() {
    if (this.activeIndex >= this.total - 1) {
      this.activeIndex = 0;
    } else {
      this.activeIndex += 1;
    }

    this.render();
  }

  onNextClick() {
    if (this.activeIndex <= 0) {
      this.activeIndex = this.total - 1;
    } else {
      this.activeIndex -= 1;
    }

    this.render();
  }

  render() {
    this.tabTargets.forEach((tab, index) => {
      const link = tab.querySelector('a');

      if (index === this.activeIndex) {
        tab.classList.add('is-active');
        link.setAttribute('aria-selected', 'true');
      } else {
        tab.classList.remove('is-active');
        link.setAttribute('aria-selected', 'false');
      }
    });

    this.panelTargets.forEach((panel, index) => {
      if (index === this.activeIndex) {
        panel.removeAttribute('hidden');
        panel.setAttribute('aria-hidden', 'false');
      } else {
        panel.setAttribute('hidden', 'hidden');
        panel.setAttribute('aria-hidden', 'true');
      }
    });

    const showNext = this.activeIndex > 0;
    const showPrevious = this.activeIndex < (this.total - 1);

    this.nextTarget[showNext ? 'removeAttribute' : 'setAttribute']('disabled', 'disabled');
    this.previousTarget[showPrevious ? 'removeAttribute' : 'setAttribute']('disabled', 'disabled');
  }
}

Updates.targets = [
  'tab',
  'panel',
  'next',
  'previous',
];

export default Updates;
